import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Global-Services/common.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css'],
  standalone: false,
})
export class PageNotFoundComponent implements OnInit {
  constructor(private gservice: CommonService) { }

  ngOnInit() {
  }
  HomePage() {
      this.gservice.HomePage();
  }
}
